<form [formGroup]="form">
  <input #input class="d-none" type="file" accept=".csv" formControlName="upload" (change)="onFileChange($event)" />
</form>

<div class="container-input-button">
  <button class="btn btn-primary" (click)="input.click()" (keypress)="input.click()" [attr.tabindex]="0">
    <span class="material-symbols-outlined d-flex m-r-4"> upload </span>
    {{ 'cart.importEntries.importProducts' | cxTranslate }}
  </button>

  <div *ngIf="input.files && input.files.length > 0" class="mt-2">
    <p>{{ 'cart.importEntries.fileUploaded' | cxTranslate: { fileName: input.files[0].name } }}</p>
  </div>
</div>